import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';

angular.module('cloudX').directive('cxRelationGroupSelect', function() {
  return {
    restrict: 'E',
    template: `
      <a href=""
         editable-text="selected"
         e-uib-typeahead="grp as grp.name for grp in options | filter:{name:($viewValue||'')}"
         e-typeahead-select-on-exact="true"
         e-typeahead-select-on-blur="false"
         e-typeahead-focus-first="false"
         e-typeahead-min-length="0"
         e-typeahead-on-select="$parent.$form.$submit()"
         e-autocomplete="off"
         e-select-on-focus
         onbeforesave="save(\$data)"
         onaftersave="commitValue()"
         blur="submit"
         edit-disabled="disabled">
        <span ng-show="selected.name" >{{selected.name}}</span>
        <i class="glyphicon glyphicon-pencil"
           ng-hide="selected.name"></i>
      </a>`,
    scope: {
      value: '=data',
      onSave: '&',
      disabled: '=?',
    },
    controller: [
      '$http',
      'appUrls',
      '$scope',
      'flySvc',
      'dialogsSvc',
      'checkSecurity',
      function($http, appUrls, $scope, flySvc, dialogsSvc, checkSecurity) {
        $scope.selected = null;
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.id === code;
          });
        };
        $http.get(`${appUrls.api}/api/RelationGroup/GetAll`).then(({ data }) => {
          $scope.options = data;
          $scope.selected = findOption($scope.value);
        });

        $scope.save = function(newValue) {
          if (!newValue || !newValue.id) {
            if (typeof newValue === 'string' && newValue !== '') {
              if (!checkSecurity('Tags:c')) {
                return '';
              }
              return dialogsSvc
                .showYesNo('AddRelationGroup', 'msgCreateRelationGroup', { value: newValue })
                .then(
                  function() {
                    return $http
                      .post(`${appUrls.api}/api/RelationGroup`, {
                        name: newValue,
                      })
                      .then(({ data }) => {
                        if (!data) return '';
                        $scope.options.push(data);
                        $scope.options.sort(dynamicSort('name'));
                        $scope.selected = data;
                        return $scope.onSave({ newValue: data.id });
                      });
                  },
                  error => {
                    if (error) flySvc.error(error);
                    return '';
                  },
                );
            }
            $scope.selected = null;
            return $scope.onSave({ newValue: null });
          }

          return $scope.onSave({ newValue: newValue.id });
        };
        $scope.commitValue = function() {
          $scope.value = $scope.selected?.id;
        };

        $scope.$watch('value', () => {
          if ($scope.options) $scope.selected = findOption($scope.value);
        });
      },
    ],
  };
});
